module.exports = __webpack_public_path__ + "static/giant_runes-774437344cd4caf49dc120558e5d0b1d.png";